import type { Tone } from '../types';

const toneColors: Record<Tone, string> = {
  ink: 'var(--ink)',
  red: 'var(--red)',
  green: 'var(--green)',
  blue: 'var(--blue)',
  amber: 'var(--amber)',
  violet: 'var(--violet)',
  gray: 'var(--muted-strong)',
  cyan: 'var(--cyan)',
  teal: 'var(--teal)',
  indigo: 'var(--indigo)',
  navy: 'var(--navy)',
  'gray-outline': 'var(--muted-strong)',
};

interface KpiCardProps {
  label: string;
  value: string;
  sub: string;
  tone?: Tone;
}

export function KpiCard({ label, value, sub, tone = 'ink' }: KpiCardProps) {
  return (
    <div className="card">
      <div className="kpi-label">{label}</div>
      <div className="kpi-value tnum" style={{ color: toneColors[tone] }}>{value}</div>
      <div className="kpi-sub">{sub}</div>
    </div>
  );
}
